import { render, staticRenderFns } from "./AppointmentFormCP.vue?vue&type=template&id=1a07eb5e&scoped=true"
import script from "./AppointmentFormCP.vue?vue&type=script&lang=js"
export * from "./AppointmentFormCP.vue?vue&type=script&lang=js"
import style0 from "./AppointmentFormCP.vue?vue&type=style&index=0&id=1a07eb5e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07eb5e",
  null
  
)

export default component.exports